import { dynamicImage } from "../../../Service/DynamicImage";

//left border
export const BORDER_LEFT = [
  {
    text: "Use the class of",
    code: ".b-l-* ",
  },
  {
    text: "for left border.",
  },
];

//Border Right
export const BORDER_RIGHT = [
  {
    text: "Use the class of",
    code: ".b-r-* ",
  },
  {
    text: "for right border.",
  },
];

//Top Border
export const BORDER_TOP = [
  {
    text: "Use the class of",
    code: ".b-t-* ",
  },
  {
    text: "for top border.",
  },
];

//Bottom Border
export const BORDER_BOTTOM = [
  {
    text: "Use the class of",
    code: ".b-b-* ",
  },
  {
    text: "for bottom border.",
  },
];

//Primary Border State
export const BORDER_PRIMARY = [
  {
    text: "Use the class of",
    code: ".b-l-* ",
  },
  {
    text: "for left border and ",
    code: ".border-3 ",
  },
  {
    text: "is used to increase the width of the border.",
  },
];

//Warning Border State
export const BORDER_WARNING = [
  {
    text: "Use the class of",
    code: ".b-l-* ",
  },
  {
    text: "for left border and ",
    code: ".border-3 ",
  },
  {
    text: "is used to increase the width of the border.",
  },
];

//Secondary Border State
export const BORDER_SECONDARY = [
  {
    text: "Use the class of",
    code: ".b-l-* ",
  },
  {
    text: "for left border and ",
    code: ".border-3 ",
  },
  {
    text: "is used to increase the width of the border.",
  },
];

export const BORDER_SECONDARY_LIST = [
  {
    title: "Lola Stanford",
    color: "danger",
    tag: "Issue",
  },
  {
    title: "Caitlin Coungeau",
    color: "primary",
    tag: "Social",
  },
  {
    title: "Graciela McClaran",
    color: "danger",
    tag: "Issue",
  },
];

//Absolute Cards
export const CARD_ABSOLUTE = [
  {
    className:"bg-primary",
    src:dynamicImage("blog/img.png"),
    span:"We provide end to end digital solutions, right from designing your website/application development: Domain, Web Hosting, Email Hosting Registration, Search Engine Optimization and other Internet Marketing, Renewal of Services timely and effectively."
  },
  {
    className:"bg-secondary",
    src:dynamicImage("blog/blog.jpg"),
    span:"When someone visits your homepage, your design should inspire them to stay. Therefore, your value proposition should be established on the homepage for visitors to select to stay on your website.Building trust, expressing value,to the next step all depend on a page's design."
  },
];